import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Global/Layout/Layout';
import { v4 as uuidv4 } from 'uuid';
import { Col, Row, Accordion, Card } from 'react-bootstrap';
import styles from '../components/Page-CSS/productCategoriesTemplate.module.css';
import { RiArrowDownSLine } from 'react-icons/ri';
import SEO from '../components/Global/SEO';

const faqs = ({ data }) => {
	const { metaImage: { fluid: { src } }, metaDescription } = data.allContentfulFrequentlyAskedQuestionsPage.nodes[0];
	return (
		<Layout>
			<SEO title="Frequently Asked Questions" description={metaDescription} image={src} />
			<Row style={{ margin: '2rem 0rem' }}>
				<Col xs={12}>
					<Row
						className={styles.descriptionHolder}
						style={{ borderBottom: '1px solid rgba(128, 128, 128, 0.76)', marginBottom: '1rem' }}
					>
						<Col xs={12} sm={6} className={styles.description}>
							<h1>Frequently Asked Questions</h1>
							<p>
								You deserve the best and we understand that you might have questions. That's why we
								wrote this page with answers to possible questions you might have
							</p>
						</Col>
					</Row>
					<Accordion defaultActiveKey="0">
						{data.allContentfulFrequentlyAskedQuestions.nodes.map((faq) => (
							<Card key={uuidv4()} style={{ marginTop: '1rem' }}>
								<Accordion.Toggle
									as={Card.Header}
									eventKey={faq.number}
									style={{ backgroundColor: 'white', border: 'none' }}
								>
									{faq.question}{' '}
									<RiArrowDownSLine style={{ marginTop: '0.3rem', fontWeight: 'bold' }} />
								</Accordion.Toggle>
								<Accordion.Collapse
									eventKey={faq.number}
									style={{
										backgroundColor: 'white',
										borderTop: '1px solid grey'
									}}
								>
									<Card.Body>{faq.answer.answer}</Card.Body>
								</Accordion.Collapse>
							</Card>
						))}
					</Accordion>
				</Col>
			</Row>
		</Layout>
	);
};

export default faqs;

export const query = graphql`
	{
		allContentfulFrequentlyAskedQuestions {
			nodes {
				question
				answer {
					answer
				}
				number
			}
		}
		allContentfulFrequentlyAskedQuestionsPage {
			nodes {
				metaDescription
				metaImage {
					fluid {
						src
					}
				}
			}
		}
	}
`;
